// 验证发起融资和填写订单时表单完整性
function validateForm(form, type = 'financ', productInfo = false) {
  // 数字/货币金额 (只支持正数）
  const regLoanNumber = new RegExp(
    /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
  )
  const regIsLoanQuotaDot = new RegExp(/^\d+\.\d+$/) // 是否小数
  // 为空或不为数字
  const amount = Number(form.amount)
  if (amount === 0) {
    return '请输⼊融资金额'
  }
  if (productInfo) {
    if (productInfo.quotaRangeEnd < amount) {
      //  return "该产品的'贷款额度'与您的融资需求不匹配"
      return {
        text: "该产品的'贷款额度'与您的融资需求不匹配，请输入该产品额度范围内的金额或更换其他产品"
      }
    }
  }
  if (!regLoanNumber.test(amount) || regIsLoanQuotaDot.test(amount) || amount < 1) {
    return '融资金额格式错误'
  }
  if (form.termRangeId === '') {
    return '请选择融资期限'
  }
  // eslint-disable-next-line no-mixed-operators
  if (form.termRangeId === -1 && !form.timeLimit) {
    return '请输入融资期限'
  }
  if (form.termRangeId === -1 && form.timeLimit.split('.').length >= 2) {
    return '融资期限格式错误'
  }
  const timeLimit = Number(form.timeLimit)
  if (form.timeLimit !== '') {
    if (!regLoanNumber.test(timeLimit) || regIsLoanQuotaDot.test(timeLimit) || timeLimit < 1) {
      return '融资期限格式错误'
    }
  }
  if (productInfo && form.termRangeId === -1) {
    if (productInfo.termRangeStart > form.timeLimit || productInfo.termRangeEnd < form.timeLimit) {
      return {
        text: "该产品的'贷款期限'与您的融资需求不匹配，请输入该产品贷款期限内的时间或更换其他产品"
      }
    }
  }
  if (form.financingCategory === '' && typeof form.financingCategory !== 'object') {
    return '请选择融资类型'
  }
  if (form.loanUse.length > 20) {
    return '资金用途不能超过 20 个字'
  }
  if (!form.guaranteeMeansIds || !form.guaranteeMeansIds.length) {
    return '请选择担保方式'
  }
  if (!form.enterpriseAreaIds.length) {
    return '请选择经营地址'
  }
  return true
}

export { validateForm }
